import React from 'react';
import cx from 'classnames';

import Badge, { BadgeProps, BackgroundColor } from '../Badge';

import { Body2, Heading2, Subtitle2 } from '../Typography';

import styles from './index.module.scss';

export enum TreatmentStatus {
  COMPLETED = 'completed',
  ACTIVE = 'active',
  CANCELLED = 'cancelled',
}

const BadgeBackgroundColorMap: Record<TreatmentStatus, BackgroundColor> = {
  [TreatmentStatus.COMPLETED]: BackgroundColor.GRADIENT,
  [TreatmentStatus.ACTIVE]: BackgroundColor.GREEN,
  [TreatmentStatus.CANCELLED]: BackgroundColor.RED,
};

export interface TreatmentHeaderSectionProps {
  status: TreatmentStatus;
  badge: BadgeProps;
  title: string;
  imageUrlDesktop: string;
  imageAltDesktop: string;
  imageUrlMobile: string;
  imageAltMobile: string;
  avatarUrl?: string;
  avatarAlt?: string;
  doctorLabel: string;
  doctorName: string;
  startDateLabel: string;
  startDateText: string;
  endDateLabel?: string;
  endDateText?: string;
  className?: string;
}

const TreatmentHeaderSection: React.FC<TreatmentHeaderSectionProps> = ({
  badge,
  status,
  title,
  imageUrlDesktop,
  imageAltDesktop,
  imageUrlMobile,
  imageAltMobile,
  avatarUrl,
  avatarAlt,
  doctorLabel,
  doctorName,
  startDateLabel,
  startDateText,
  endDateLabel,
  endDateText,
  className,
}) => {
  const badgeBackgroundColorValue = BadgeBackgroundColorMap[status];

  return (
    <div className={cx(styles.wrapper, className)}>
      {imageUrlMobile && (
        <img
          src={imageUrlMobile}
          alt={imageAltMobile}
          className={cx(styles.image, styles.imageMobile)}
        />
      )}

      {imageUrlDesktop && (
        <img
          src={imageUrlDesktop}
          alt={imageAltDesktop}
          className={cx(styles.image, styles.imageDesktop)}
        />
      )}

      <div className={styles.content}>
        <Badge
          className={styles.badge}
          text={badge.text}
          backgroundColor={badgeBackgroundColorValue}
        />
        <Heading2 className={styles.title}>{title}</Heading2>

        <div className={styles.imageAndTextWrapper}>
          {avatarUrl && (
            <img className={styles.avatar} src={avatarUrl} alt={avatarAlt} />
          )}

          <div className={styles.textWrapper}>
            <div className={styles.infoBlock}>
              <Body2>{doctorLabel}</Body2>
              <Subtitle2>{doctorName}</Subtitle2>
            </div>
            <div className={styles.infoBlock}>
              <Body2>{startDateLabel}</Body2>
              <Subtitle2>{startDateText}</Subtitle2>
            </div>
            {endDateLabel && endDateText && (
              <div className={styles.infoBlock}>
                <Body2>{endDateLabel}</Body2>
                <Subtitle2>{endDateText}</Subtitle2>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TreatmentHeaderSection;
